  import * as ActionTypes from "../Types/ActionTypes";

  export const PendingDashboard = (
    state = {
      isLoading: false,
      pendingDashboardState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.PENDING_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.PENDING:
        return {
          ...state,
          isLoading: false,
          pendingDashboardState: action.payload,
        };

      case ActionTypes.PENDING_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
